<div
  *ngIf="visible"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
  role="dialog"
  aria-labelledby="jobseeker-modal-title"
  aria-modal="true"
>
  <!-- Modal container -->
  <div class="relative max-w-5xl w-full bg-white rounded-lg border border-neutral-base shadow-lg overflow-hidden">

    <!-- Header -->
    <div class="flex justify-between items-center border-b border-neutral-base p-4">
      <h2 id="jobseeker-modal-title" class="c-h2 flex-1 text-center mt-4">
        {{ jobseeker?.nombre ? jobseeker.nombre : 'Detalle del candidato' }}
      </h2>
      <button
        (click)="closeDialog()"
        aria-label="Cerrar la ventana emergente"
        class="text-neutral-dark hover:text-neutral-base text-xl font-bold"
      >
        ✕
      </button>
    </div>

    <!-- Body -->
    <div class="p-6 space-y-4 text-neutral-dark text-justify leading-relaxed">

      <div class="space-y-1">
        <p><strong>NIF:</strong> {{ jobseeker?.NIF || 'Sin especificar' }}</p>
        <p><strong>Nombre:</strong> {{ jobseeker?.nombre || 'Sin especificar' }}</p>
        <p><strong>Municipio:</strong> {{ jobseeker?.ciudad || 'Sin especificar' }}</p>
        <p><strong>Provincia:</strong> {{ jobseeker?.provincia || 'Sin especificar' }}</p>
        <p><strong>Teléfono:</strong> {{ jobseeker?.telefono || 'Sin especificar' }}</p>
        <p><strong>Correo electrónico:</strong> {{ jobseeker?.email || 'Sin especificar' }}</p>
      </div>

      <div *ngIf="seccionesJustificacion" class="space-y-2">
        <p *ngIf="seccionesJustificacion['EXPERIENCIA']"><strong>Experiencia:</strong> {{ seccionesJustificacion['EXPERIENCIA'] }}</p>
        <p *ngIf="seccionesJustificacion['FORMACIÓN']"><strong>Formación:</strong> {{ seccionesJustificacion['FORMACIÓN'] }}</p>
        <p *ngIf="seccionesJustificacion['COMPETENCIAS']"><strong>Competencias:</strong> {{ seccionesJustificacion['COMPETENCIAS'] }}</p>
        <p *ngIf="seccionesJustificacion['VALORACIÓN GENERAL']"><strong>Valoración general:</strong> {{ seccionesJustificacion['VALORACIÓN GENERAL'] }}</p>
      </div>

    </div>

    <!-- Footer con botón Desy -->
    <div class="border-t border-neutral-base p-4 text-right">
      <desy-button
        [text]="'Cerrar detalle'"
        [classes]="'c-button--primary w-58'"
        (clickEvent)="closeDialog()">
      </desy-button>
    </div>

  </div>
</div>
